(() => {
  if (window.rocketAccessoryCartReady) return;
  window.rocketAccessoryCartReady = true;

  async function readCart(root) {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error();
    return response.json();
  }

  function hasController(cart, id) {
    return cart.items.some(item => String(item.variant_id || item.id) === String(id));
  }

  function appendItem(payload, data, index) {
    if (!data.get('id')) throw new Error();
    for (const [name, value] of data.entries()) {
      const field = name.match(/^(id|quantity|selling_plan|properties)(\[.*\])?$/);
      if (field) payload.append('items[' + index + '][' + field[1] + ']' + (field[2] || ''), value);
    }
    if (!data.has('quantity')) payload.append('items[' + index + '][quantity]', '1');
  }

  function askController(dialog) {
    return new Promise(resolve => {
      function finish(value) {
        dialog.removeEventListener('click', onClick);
        dialog.removeEventListener('close', onClose);
        if (dialog.open) dialog.close();
        resolve(value);
      }
      function onClick(event) {
        const choice = event.target.closest('[data-upsell-choice]');
        if (choice) finish(choice.dataset.upsellChoice);
        else if (event.target === dialog) finish(null);
      }
      function onClose() { finish(null); }
      dialog.addEventListener('click', onClick);
      dialog.addEventListener('close', onClose);
      dialog.showModal();
    });
  }

  function feedback(section, message, error) {
    const region = section.querySelector('[data-upsell-feedback]');
    if (!region) return;
    region.querySelector('[data-upsell-message]').textContent = message;
    region.querySelector('a').hidden = error;
    region.setAttribute('role', error ? 'alert' : 'status');
    region.hidden = false;
  }

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-upsell-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const section = form.closest('[data-product-section]');
    if (!section || section.dataset.upsellBusy === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    const region = section.querySelector('[data-upsell-feedback]');
    const controllerForm = section.querySelector('.rg-pdp-form');
    const dialog = section.querySelector('[data-upsell-controller-dialog]');
    const root = window.Shopify?.routes?.root || '/';
    let added = false;
    section.dataset.upsellBusy = 'true';
    button.disabled = true;
    if (region) region.hidden = true;
    try {
      const accessory = new FormData(form);
      let controller = controllerForm ? new FormData(controllerForm) : null;
      let cart = null;
      let includeController = false;
      const controllerButton = section.querySelector('[data-product-submit]');
      if (dialog && controller?.get('id') && controllerButton && !controllerButton.disabled) {
        cart = await readCart(root);
        if (!hasController(cart, controller.get('id'))) {
          const choice = await askController(dialog);
          if (choice !== 'both' && choice !== 'accessory') return;
          includeController = choice === 'both';
        }
      }
      if (includeController) {
        if (!controllerForm.reportValidity()) return;
        controller = new FormData(controllerForm);
        cart = await readCart(root);
        includeController = !hasController(cart, controller.get('id'));
      }
      const payload = new FormData();
      appendItem(payload, accessory, 0);
      if (includeController) appendItem(payload, controller, 1);
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload
      });
      if (!response.ok) {
        const problem = await response.json().catch(() => ({}));
        throw new Error(typeof problem.description === 'string' ? problem.description : '');
      }
      added = true;
      button.textContent = button.dataset.addedLabel;
      feedback(section, region?.dataset.successMessage || button.dataset.addedLabel, false);
      const updatedCart = await readCart(root).catch(() => null);
      if (updatedCart) {
        document.querySelectorAll('.cart-count').forEach(count => {
          const itemCount = Number(updatedCart.item_count) || 0;
          count.textContent = String(itemCount);
          count.hidden = itemCount === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));
      }
    } catch (error) {
      feedback(section, error.message || region?.dataset.errorMessage || '', true);
    } finally {
      section.dataset.upsellBusy = 'false';
      button.disabled = false;
      if (button.isConnected) button.focus({ preventScroll: true });
      if (added) window.setTimeout(() => {
        if (button.isConnected) button.textContent = button.dataset.addLabel;
      }, 2200);
    }
  }, true);
})();
